"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchConstructionState = exports.setConstructionState = void 0;
// 施工時間のラジオボタンの状態をlocalStorageに保存
var setConstructionState = function () {
    console.log('setConstructionState');
    var sendButton = document.querySelector('input#gform_next_button_1_10, input#gform_next_button_28_10');
    if (sendButton === null)
        return; // input#gform_next_button_{1|28}_10 がない場合は何もしない
    var saveConstructionTime = function () {
        // 施工時間のラジオボタンを取得
        var radio = document.querySelector('input[name="input_9"]:checked');
        // 選択されたラジオボタンの値を localStorage に保存
        // input[name="input_9"] がない場合は何もしない
        if (radio !== null) {
            localStorage.setItem('Construction_time', radio.value);
        }
    };
    // input#gform_next_button_{1|28}_10 がクリックされたとき
    sendButton.addEventListener('click', saveConstructionTime);
    // input#gform_next_button_{1|28}_10 がEnterキーで送信されたとき
    sendButton.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            saveConstructionTime();
        }
    });
};
exports.setConstructionState = setConstructionState;
var fetchConstructionState = function () {
    var _a;
    // 昼間 = 0, 夜間 = 1, エラー = null
    return (_a = localStorage.getItem('Construction_time')) !== null && _a !== void 0 ? _a : null;
};
exports.fetchConstructionState = fetchConstructionState;
